export const GET_ITEMS = "GET_ITEMS"
export const GET_ITEMS_SUCCESS = "GET_ITEMS_SUCCESS"
export const GET_ITEMS_FAILED = "GET_ITEMS_FAILED"

export const GET_ITEM = "GET_ITEM"
export const GET_ITEM_SUCCESS = "GET_ITEM_SUCCESS"
export const GET_ITEM_FAILED = "GET_ITEM_FAILED"

export const REGISTER_ITEM = "REGISTER_ITEM"
export const REGISTER_ITEM_SUCCESS = "REGISTER_ITEM_SUCCESS"
export const REGISTER_ITEM_FAILED = "REGISTER_ITEM_FAILED"

export const UPDATE_ITEM = "UPDATE_ITEM"
export const UPDATE_ITEM_SUCCESS = "UPDATE_ITEM_SUCCESS"
export const UPDATE_ITEM_FAILED = "UPDATE_ITEM_FAILED"

export const GET_EVENTS = "GET_EVENTS"
export const GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS"
export const GET_EVENTS_FAILED = "GET_EVENTS_FAILED"

export const RESET_ITEM = "RESET_ITEM";

